import AppLayout from '../../layouts/AppLayout';
import CopyableEmail from '../../components/CopyableEmail';

const LandingPage = ({ authError, isAuthenticating, onLogin, sessionExpired }) => (
    <AppLayout>
        <section className="usa-section landing-hero">
            <div className="grid-container">
                <div className="grid-row grid-gap">
                    <div className="tablet:grid-col-8">
                        <h1 className="usa-heading-xl landing-hero__title">
                            Welcome to JCWA Unlock
                        </h1>
                        <p className="usa-intro landing-hero__subtitle">
                            Manage access to JCWA applications with single sign-on. Please ensure your Common Access Card (CAC) is fully seated before you continue.
                        </p>
                        {sessionExpired ? (
                            <div className="usa-alert usa-alert--warning" role="alert">
                                <div className="usa-alert__body">
                                    <p className="usa-alert__text">
                                        You have been logged out because your session expired. Please sign in again.
                                    </p>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>

        <section className="usa-section">
            <div className="grid-container">
                <div className="grid-row grid-gap">
                    <div className="tablet:grid-col-8">
                        <div className="usa-card landing-card">
                            <div className="usa-card__container">
                                <div className="usa-card__header">
                                    <h2 className="usa-card__heading">Sign in</h2>
                                </div>
                                <div className="usa-card__body">
                                    <p className="usa-prose">
                                        Login to manage your application access requests.
                                    </p>
                                    {authError ? (
                                        <div className="usa-alert usa-alert--error" role="alert">
                                            <div className="usa-alert__body">
                                                <p className="usa-alert__text">{authError}</p>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="usa-card__footer">
                                    <button
                                        type="button"
                                        className="usa-button"
                                        onClick={onLogin}
                                        disabled={isAuthenticating}
                                    >
                                        {isAuthenticating
                                            ? 'Connecting to JCWA ICAM...'
                                            : 'Login with JCWA ICAM'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tablet:grid-col-4">
                        <div className="usa-prose">
                            <h3>Need help?</h3>
                            <p>
                                If you are having login issues, please contact the JCWA Service
                                Desk (
                                <CopyableEmail
                                    email="OPSSUPPORT@groups.af.mil"
                                    fallback={null}
                                    className="copyable-email"
                                />
                                ) if you need assistance.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </AppLayout>
);

export default LandingPage;
